import helpStyle from "./help.module.css"


export default function Help() {
    return(
        <div className={helpStyle['wrap']}>
            <div>{`<안내>`}</div>
            <div>1. 왼쪽 상단에서 행사를 선택하세요.</div>
            <div>2. 왼쪽 하단 달력에서 날짜를 선택하세요.</div>
            <div>3. 오른쪽 하단에서 일정을 추가한 후 내용을 입력하고 등록하세요.</div>
            <div>※ 날짜를 1개 선택시 일정의 등록, 수정, 삭제 가능</div>
            <div>※ 날짜를 2개 이상 선택시 일정 등록만 가능</div>
            <div>※ 신청자가 있는 경우 일정 삭제 및 시간, 가격 수정 불가</div>
            <div>4. 현황 버튼을 클릭하면 신청 목록을 확인할 수 있습니다.</div>
            <div>{`<왼쪽 바 소개>`}</div>
            <div>1. '도움말'을 체크하면, 일정 등록 방법을 안내해줍니다.</div>
            <div>2. '일정'에서 행사를 등록/수정/삭제하세요.</div>
            <div>3. '공지'에서 학부모에게 안내할 내용을 작성하세요.</div>
        </div>
    )
}